import { get, patch } from 'core_main/request';
import { addUnreadCountsToStore, updateStore } from 'core_main/store';

import { UnreadCountsState } from 'core_main/types';
import { CHAT_SESSION_STATS_ENDPOINT } from 'core_main/api/sessions/constants';
import {
  CUSTOMERS_CURRENT_ENDPOINT,
  CURRENT_CUSTOMERS_CONTEXT_ENDPOINT,
} from './constants';
import {
  convertCurrentCustomerContextResponseToCustomerDetails,
  validateUpdateCurrentCustomerParams,
} from './helpers';
import { UpdateCurrentCustomerParameters } from './types';

export const updateCurrentCustomer = (
  parameters: UpdateCurrentCustomerParameters,
) => {
  const { attributes, custom } = parameters;

  const validationError = validateUpdateCurrentCustomerParams(parameters);

  if (validationError) {
    return Promise.reject(validationError);
  }

  return patch(CUSTOMERS_CURRENT_ENDPOINT, {
    body: JSON.stringify({ ...attributes, custom }),
  });
};

export const getCurrentCustomerContext = () => {
  return get(CURRENT_CUSTOMERS_CONTEXT_ENDPOINT).then((response) => {
    updateStore(
      'customerContext',
      convertCurrentCustomerContextResponseToCustomerDetails(response),
    );
    return response;
  });
};

export const fetchAndUpdateCurrentUnreadCounts = (cb?) => {
  return get(CHAT_SESSION_STATS_ENDPOINT).then((stats) => {
    const { totalUnreadCount, sessionsWithUnreads } = stats.data.attributes;
    const unreadCountsState: UnreadCountsState = {
      total: totalUnreadCount,
      conversations: { ...sessionsWithUnreads },
    };

    addUnreadCountsToStore(unreadCountsState);
    if (typeof cb === 'function') cb();
    return unreadCountsState;
  });
};
